export default function Privacy(){

    return (
        <main className="content">
            <div className="tabcontent">
                <div className="p-3 rounded">

                    <h2>Privacy Statement (FAQs)</h2>
                    <ul>
                        <li>
                            <strong>Does the Internet of Werid Things store or use any of your data?</strong>
                            <p>Nope! We just don't. We want to protect your data, and the best way to do it
                                is by not storing your data on our end at all. And Firestore storage is quite expensive (lol)</p>
                        </li>
                        <li>
                            <strong>Does the Internet of Werid Things use any Cookies?</strong>
                            <p>Yes! We use cookies to enhance your browsing expereince, and it is necessary for user account management. But don't worry, cookies are stored on your local device. No one, but you, have access to them.</p>
                        </li>
                        <li>
                            <strong>Does the Internet of Werid Things sell your information?</strong>
                            <p>Nope! We don't collect your information at all to begin with. We don't even have ads</p>
                        </li>
                    </ul>
                    <br/>

                    <h2>Terms of Use</h2>
                    <p>
                        The Term of Use applies to the Internet of Weird Things located at www.iowt-now.com, 
                        and all its subsidiaries and affiliates. By using our site, you agree to the Terms of Use
                    </p>
                    <ul>
                        <li><p>
                            We are enthusiastic web developers that love developing and sharing, so please be ethical and friendly while using our sites.
                            <strong> IF YOU CAN'T BEHAVE ETHICALLY AND FRIENDLY, DO NOT USE OUR SITES. </strong>
                            <strong> Don't try to heck our sites, c'mon man! </strong> If you'd like to join us, please send us a message!
                        </p></li>
                        <li><p>
                            Other than the audio souces used in the <i>Simple ASMR</i> app and credited in our <i>Home</i> page, 
                            we are the owner and the licensee of all intellectual properties in our sites, and in the material 
                            published on it. Those works are protected by copyright laws and treaties around the world. 
                            All rights are reserved.
                        </p></li>
                        <li><p>
                            We reserve the right to add, enhance or withdraw any service we provide on our sites without notice. We will not be liable for any downtime.
                        </p></li>
                        <li><p>
                            You may not use our sites for any illegal or unauthorized purpose nor may you, in the use of the service, violate any laws in your jurisdiction 
                            (including but not limited to copyright laws). You are responsible for complying with any law, rules, and regulations applicable to you.
                        </p></li>
                        <li><p>
                            You must not transmit any worms or viruses or any code of a destructive nature. 
                        </p></li>
                        <li><p>
                            Any breach or violations of any of our terms will result in an access block from your IPs
                        </p></li>
                    </ul>
                </div>
            </div>
        </main>
    );
}